import * as React from 'react'
import { Chip } from '@material-ui/core'
import cn from 'classnames'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import moment from 'moment'
import * as styles from './styles.module.css'

const JetsoStatusChip = ({news}) => {
  const { t } = useTranslation()
  
  const isEnd = news.promote_end_at ? moment(news.promote_end_at).add(1, 'd').unix() < Date.now() / 1000 : false
  const isScheduling = news.publish_at ? Date.now() < new Date(news.publish_at).getTime() : false
  
  const getStatus = () => {
    if (news.is_banned) {
      return t('jetso.banned')
    }
    if (news.is_published) {
      if (isEnd) {
        return t('jetso.ended')
      }
      if(news.is_pause) {
        return t('jetso.pasued')
      }
      if (isScheduling) {
        return t('jetso.scheduling')
      }
      return t('jetso.publishing')
    }
    return t('jetso.draft')
  }

  const getStatusClass = () => {
    if (news.is_banned) {
      return styles.banned
    }
    if (news.is_published) {
      if (isEnd) {
        return styles.pasued
      }
      if(news.is_pause) {
        return styles.pasued
      }
      if (isScheduling) {
        return styles.scheduling
      }
      return styles.publishing
    }
    return styles.pasued
  }

  return (
    <Chip className={cn(styles.status, getStatusClass())} label={getStatus()} size="small" />
  )
}

export default JetsoStatusChip